<template>
    <div class="border p-1 rounded mb-1">
        <h5 class="text-muted">Sicil Bilgisi</h5>
        <div class="row align-items-end">
            <!-- <div class="col-md-3 mb-1">
                <label class="from-label">Sicil Numarası</label>
                <input readonly :value="value.RegistrationCode" class="form-control" placeholder="Sicil Numarası"/>
            </div> -->
            <div class="col-md-3 mb-1 mb-md-0">
                <label class="from-label">SGK Sicil Numarası</label>
                <v-validator :errors="errors" parameter="BusinessAgreement.SGKRegistryNumber" :watch="value.SGKRegistryNumber">
                    <input v-model="value.SGKRegistryNumber" class="form-control" placeholder="SGK Sicil Numarası"/>
                </v-validator>
            </div>
            <!-- <div class="col-md-3 mb-1">
                <label class="from-label">SGK Şube</label>
                <v-validator :errors="errors" parameter="BusinessAgreement.SGKBranchId" :watch="value.SGKBranchId">
                    <v-select-list :options="sgkBranches" label="Name" v-model="sgkBranch" placeholder="SGK Şube"></v-select-list>
                </v-validator>
            </div> -->
            <!-- <div class="col-md-3 mb-1">
                <label class="from-label">Maliyet Merkezi</label>
                <v-select-list :options="expenseLocations" label="Name" v-model="expenseLocation" placeholder="Maliyet Merkezi"></v-select-list>
            </div> -->
            <!-- <div class="col-md-3 mb-1">
                <label class="from-label">Organizasyonel Konum</label>
                <v-select-list :options="collars" label="Name" v-model="collar" placeholder="Organizasyonel Konum"></v-select-list>
            </div> -->
            <div class="col-md-3 mb-1 mb-md-0">
                <label class="form-label">Sigortalı Türü</label>
                <v-validator :errors="errors" parameter="BusinessAgreement.SGKInsuranceType" :watch="value.SGKInsuranceType">
                    <v-select-list :options="insuredTypes" v-model="insuredType" placeholder="Sigortalı Türü" label="Value"></v-select-list>
                </v-validator>
            </div>
            <div class="col-md-auto text-right">
                <v-executer :loading="loading" text="Sözleşme Bilgilerini Güncelle" :action="save"></v-executer>
            </div>
        </div>
    </div>
</template>

<script>
import CompanyApi from '@/api/company';
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
import SystemDataApi from '@/api/system-data'
import EmployeeOperationsApi from '@/api/employee-operations' 
import Additional from '@/utilities/additional'
export default {
    props:{
        id:[String,Number],
        value:Object,
        getPersonal:Function,
    },
    data() {
        return {
            sgkBranches:[],
            expenseLocations:[],
            collars:[],
            insuredTypes:[],
            loading:false,
            errors:{}
        }
    },
    mounted(){
        this.getBranches()
        //this.getExpenseLocations()
        // this.getCollars()
        this.getInsuredTypes()
    },
    methods: {
        getBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sgkBranches = res.data.Data
            })
        },
        getExpenseLocations(){
            HumanResourcesParameterApi.ExpenseLocation.List().then(res=>{
                this.expenseLocations = res.data.Data
            })
        },
        getCollars(){
            SystemDataApi.CollarStatus().then(res=>{
                this.collars = res.data.Data
            })
        },
        getInsuredTypes(){
            EmployeeOperationsApi.Employee.SGK.Type("sigortalituru").then(res=>{
                this.insuredTypes = res.data.Data
            })
        },
        async save(){
            let data = {
                Step:7,
                EmployeeId:this.id,
                BusinessAgreement:this.value,
            }
            let formData = await Additional.ToFormData(data)
            this.loading = true
            EmployeeOperationsApi.Employee.CreateOrUpdate(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.getPersonal()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
    },
    computed:{
        sgkBranch:{
            get:function(){
                return this.sgkBranches.find(b=>b.Id==this.value.SGKBranchId)
            },
            set:function(value){
                this.value.SGKBranchId = value?.Id || null
            }
        },
        expenseLocation:{
            get:function(){
                return this.expenseLocations.find(b=>b.Id==this.value.ExpenseLocationId)
            },
            set:function(value){
                this.value.ExpenseLocationId = value?.Id || null
            }
        },
        // collar:{
        //     get:function(){
        //         return this.collars.find(b=>b.Id==this.value.CollarStatusId)
        //     },
        //     set:function(value){
        //         this.value.CollarStatusId = value?.Id || null
        //     }
        // },
        insuredType:{
            get:function(){
                return this.insuredTypes.find(i=>i.Code==this.value.SGKInsuranceType)
            },
            set:function(value){
                this.value.SGKInsuranceType = value?.Code || null
            }
        },
    }
}
</script>